module.exports = __webpack_public_path__ + "static/uxriga-0793ea8fbcabd1d2c51464663628da06.png";